import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '../../../components/Box/Box'
import { getSignatureRequestUrl } from '../../../_services/v2/documents.service'
import HelloSign from 'hellosign-embedded'

export const ESignPage = ({ match }) => {
  const { env } = useSelector((state) => state.env)
  const globalId = match.params.global_id

  useEffect(() => {
    async function fetchData() {
      const { sign_url, client_id } = await getSignatureRequestUrl(globalId)

      const client = new HelloSign({
        clientId: client_id,
      })

      client.open(sign_url, {
        allowCancel: false,
        container: document.getElementById(`this-container`),
      })
    }
    fetchData()
  }, [])

  return <Box boxHeight="100%" boxMinHeight="calc(100vh - 62px)" id="this-container" />
}
